import type { ComponentStyleConfig } from "@chakra-ui/theme";
import { textStyles } from "theme/text-styles";
import { remCalc } from "theme/utils";

export const Input: ComponentStyleConfig = {
  baseStyle: {
    field: {
      borderRadius: "base",
      px: "smaller",
      py: "smallest",
      _placeholder: {
        color: "brand.textSecondary.light",
      },
    },
    element: {
      width: "icon.md",
      height: "100%",
      right: "smallest",
      svg: {
        boxSize: "icon.md",
      },
    },
  },
  sizes: {
    md: {
      field: {
        borderRadius: "base",
        height: remCalc(44),
        ...textStyles.caption1,
        _placeholder: {
          ...textStyles.caption1,
        },
      },
    },
    lg: {
      field: {
        borderRadius: "base",
        height: remCalc(60),
        ...textStyles.body3,
        _placeholder: {
          color: "brand.textSecondary.light",
          ...textStyles.body3,
        },
      },
    },
  },
  variants: {
    outline: {
      field: {
        bg: "white",
        color: "brand.text.light",
        borderColor: "brand.border.light",
        _hover: {
          borderColor: "new.gray.500",
        },
        _focusVisible: {
          borderColor: "transparent",
          boxShadow: "outline",
          outline: "none",
        },
        _invalid: {
          borderColor: "new.red.500",
          boxShadow: "none",
          _focusVisible: {
            borderColor: "transparent",
            boxShadow: "outlineRed",
            outline: "none",
          },
          _disabled: {
            bg: "brand.backgroundSecondary.light",
            borderColor: "brand.backgroundSecondary.light",
            opacity: 1,
          },
        },
        _disabled: {
          bg: "brand.backgroundSecondary.light",
          borderColor: "brand.backgroundSecondary.light",
          opacity: 1,
        },
      },
    },
  },
  defaultProps: {
    size: "md",
  },
};
